import { ProductMasterData } from '../types/product_master_data/productMasterData';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/product_master_data/list';

export namespace ProductMasterDataRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<ProductMasterData>> => {
    return (await http.post(LIST, payload)).data;
  };
}
